<template>
  <div class="muban">

    <div class="banner">
      <img :src="require('../assets/images/banner.png')" alt="主播简介banner">
    </div>

    
    <div class="content">

      <div class="zb_cats">
        <el-tabs v-model="tab_num">
          <el-tab-pane v-for="(item,i) of category" :key="i" :label="item.name" :name="'tab_'+i">
            <div class="nonMoodAnchors list_nonMoodAnchors">

                  <div v-for="(row,k) of data[item.id]" class="anchor-show">

                      <div class="anchor-item1" >
                          <div  class="anchor-specific">
                              <div  class="anchor-info-index">
                                  <div  class="anchor-imgstyle">
                                    <img  :src="row.imgurl" alt="主播头像" class="anchor-img">
                                  
                                  </div>                                 

                              </div>

                              <div  class="anchor-name"> 
                                {{row.anchorName}} 
                                <div  class="anchor-desc"> {{row.musicName}} </div>
                              </div>
                          </div>
                      </div>
                      
                      <div class="play_btn">
                        <div @click="play(row,$event)" class="plyauo">
                          <img  alt="播放"
                          v-if="playId == row.id" :src="require('../assets/images/paurse.png')" />
                          <img  alt="播放" v-else :src="require('../assets/images/bofanghui.png')" />
                           <span> 点击试听</span>
                        </div>
                        <div>
                          <router-link :to="{path:'/hecheng',query:{id:row.id}}">
                            <i class="el-icon-mic"></i> 去配音
                          </router-link>
                        </div>
                                     
                      </div>
                  </div>

            </div>
          </el-tab-pane>  
        </el-tabs>
      </div>

    </div>

 
<audio :src="mp3url" ref="audio" style="display:none;" @pause="pause()"> 
</audio>
     
   
  </div>
</template>
<style scoped>

.play_btn{
  padding:16px 20px;
  display:flex;
  line-height:24px;
  justify-content: space-between;
}
.play_btn img{
  widht:24px;
  height:24px;
  vertical-align: middle;
}

.list_nonMoodAnchors{
  height:auto!important;
  max-height: 100%!important;
  padding-bottom:24px;
  display: grid!important;
    
    justify-content: center!important;
    grid-gap: 2.26667vw 1.33333vw!important;
    grid-template-columns: repeat(auto-fill, 16.66667vw)!important;
}

.list_nonMoodAnchors .anchor-show:nth-child(4n+1) .anchor-item1 {
  background-image: url('../assets/images/anchor1.png');
}

.list_nonMoodAnchors .anchor-show:nth-child(4n+2) .anchor-item1 {
  background-image: url('../assets/images/anchor2.png');
}

.list_nonMoodAnchors .anchor-show:nth-child(4n+3) .anchor-item1 {
  background-image: url('../assets/images/anchor3.png');
}

.list_nonMoodAnchors .anchor-show:nth-child(4n+4) .anchor-item1 {
  background-image: url('../assets/images/anchor4.png');
}
.anchor-show{
    box-shadow: 0px 0.26667vw 1.86667vw 0px rgba(195,195,195,.19);
    border-radius: 0.6vw;
    margin-top:20px;
    width:15.53333vw;
}
.anchor-show:hover{
 
  transform:scale(1.05);
  cursor:pointer;
  transition:all .2s
}

.plyauo:hover{
  cursor:pointer;
  color:#409EFF;
}

.banner {
    padding-top:30px;
    margin: 0 auto;
    text-align:center;
   
}
.banner img {
    width: 80%;
    height: auto;
}

.muban {
  background-color:#fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding:0 8%;
}
.el-breadcrumb {
  font-size: 18px !important;
  line-height: 2;
}

.el-breadcrumb {
  padding: 10px 20px;
}
.content {
  display: flex;
  padding: 0 20px 10px 20px;
}
.content > span {
  font-size: 18px;
  display: inline-block;
  width: 100px;
  height: 22px;
  margin-top: 10px;
  padding:0 15px;
}
.content li {
  display: inline-block;
  width: 109px;
  text-align: center;
  font-size: 18px;
  margin: 10px 10px;

}

.content li:hover {
  color: #00c2fc;
  cursor: pointer;
}
.active {
  background:rgba(237,251,255,1);
  border-radius:10px;
}

</style>
<script>
export default {
  data() {
    return {
      activeIndex:"3",
      tab_num:"",
      category:[],
      mp3url:"",
      anchor_index:-1,
     
      isPlay: false,
      playId:0,
      data:[]
    };
  },
  methods: {
    //获取分类
    getCategory(){
      this.axios({
        method: "post",
        url: "/api/tts/cat_list",
        data: {},
      }).then((res) => {
        
          this.category=res.data.data.items;
          
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //所有数据
    getData() {
      this.axios({
        method: "post",
        url: "/api/tts/list_new",
        data: {},
      })
        .then((res) => {
          // console.log(res.data.items);
          let arr=res.data.data;
          
          var map = {};
          
          for (var i = 0; i < arr.length; i++) {
            map[arr[i].id] = arr[i].list;

          }        
          
          this.data=map;
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    anchor_hover(i,item){
      this.anchor_index=i;
      this.defaultItem = item;
      this.dialogTableVisible = false;
    },
    play(item,e){

      if(this.isPlay){
        let plid = this.playId;
        this.stop();
        if(plid == item.id){
          console.log("stop")
          return;
        }
      }

      console.log("play "+item.id);
      
      this.mp3url = item.demoUrl;
      this.playId = item.id;
      console.log(this.mp3url)
      
      if(this.$refs.audio.readyState != 4){
        this.$refs.audio.oncanplay =()=>{
            this.playAdu();
        }
      }else{
        this.playAdu();
      }
      
    },
    stop(){
      this.$refs.audio.pause();
      this.isPlay = false;
      this.playId = 0;
    },
    pause(){
      this.isPlay = false;
      this.playId = 0;
    },
    playAdu(){
      this.isPlay = true;
      this.$refs.audio.play();
    }
  },
  mounted() {
       this.getData();
       this.getCategory();
       this.tab_num = "tab_0";
       this.$store.commit("setActiveIndex",this.activeIndex)
    },
};
</script>
